import { apiBaseQuery } from 'store/api';
import { getAccessToken } from 'utils/deferredToken';
// import { API_URL } from 'constants';

const baseQuery = () => async (params, { getState }) => {
  const { apiUrl } = getState().initialize.config;
  const token = await getAccessToken();
  return apiBaseQuery({
    baseURL : apiUrl,
    ...params,
    token,
  });
};

export default baseQuery;
